import { Key, Trash } from "@phosphor-icons/react";

function ConfiguredView({ oidc, onRemove }) {
  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        <div><div className="label-sm text-zinc-500">Provider</div><div className="text-sm font-medium capitalize mt-1">{oidc.provider_name}</div></div>
        <div><div className="label-sm text-zinc-500">Slug</div><div className="font-mono text-sm mt-1">{oidc.slug}</div></div>
        <div className="col-span-2"><div className="label-sm text-zinc-500">Discovery URL</div><div className="font-mono text-[11px] truncate mt-1">{oidc.discovery_url}</div></div>
      </div>
      <div className="bg-zinc-50 border border-zinc-200 p-3 mb-4">
        <div className="label-sm text-zinc-500">Tenant SSO sign-in URL — give this to your users</div>
        <div className="font-mono text-xs mt-1 break-all">{window.location.origin}/api/auth/oidc/{oidc.slug}/login</div>
      </div>
      <button onClick={onRemove} className="border border-[#D0021B] text-[#D0021B] text-xs font-semibold px-4 py-2 hover:bg-[#D0021B] hover:text-white transition-colors flex items-center gap-2" data-testid="oidc-remove-btn">
        <Trash size={12} /> REMOVE SSO CONFIG
      </button>
    </div>
  );
}

function OidcForm({ form, onChange, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="oidc-form">
      <div>
        <label className="label-sm text-zinc-500">Provider</label>
        <select value={form.provider_name} onChange={(e) => onChange({...form, provider_name: e.target.value})} className="w-full border-b border-zinc-300 focus:border-zinc-950 bg-transparent py-2 text-sm outline-none">
          <option value="azure_ad">Azure AD / Entra ID</option>
          <option value="okta">Okta</option>
          <option value="auth0">Auth0</option>
          <option value="google_workspace">Google Workspace</option>
          <option value="generic">Generic OIDC</option>
        </select>
      </div>
      <div>
        <label className="label-sm text-zinc-500">Scope</label>
        <input value={form.scope} onChange={(e) => onChange({...form, scope: e.target.value})} className="w-full border-b border-zinc-300 focus:border-zinc-950 bg-transparent py-2 text-sm outline-none" />
      </div>
      <div className="md:col-span-2">
        <label className="label-sm text-zinc-500">Discovery URL (.well-known/openid-configuration)</label>
        <input required value={form.discovery_url} onChange={(e) => onChange({...form, discovery_url: e.target.value})} placeholder="https://login.microsoftonline.com/{tenant-id}/v2.0/.well-known/openid-configuration" className="w-full border-b border-zinc-300 focus:border-zinc-950 bg-transparent py-2 text-sm outline-none font-mono text-[11px]" data-testid="oidc-discovery-input" />
      </div>
      <div>
        <label className="label-sm text-zinc-500">Client ID</label>
        <input required value={form.client_id} onChange={(e) => onChange({...form, client_id: e.target.value})} className="w-full border-b border-zinc-300 focus:border-zinc-950 bg-transparent py-2 text-sm outline-none font-mono" data-testid="oidc-client-id-input" />
      </div>
      <div>
        <label className="label-sm text-zinc-500">Client Secret</label>
        <input type="password" required value={form.client_secret} onChange={(e) => onChange({...form, client_secret: e.target.value})} className="w-full border-b border-zinc-300 focus:border-zinc-950 bg-transparent py-2 text-sm outline-none font-mono" data-testid="oidc-client-secret-input" />
      </div>
      <div className="md:col-span-2">
        <button type="submit" className="bg-zinc-950 text-white text-xs font-semibold px-5 py-2.5 hover:bg-[#FF3E00] flex items-center gap-2" data-testid="oidc-save-btn">
          <Key size={12} /> SAVE SSO CONFIG
        </button>
        <div className="font-mono text-[10px] text-zinc-400 mt-2">
          After saving, register your IdP redirect URI as: <code>{window.location.origin}/api/auth/oidc/{`{slug}`}/callback</code>
        </div>
      </div>
    </form>
  );
}

export default function OidcSection({ oidc, form, onFormChange, onSave, onRemove }) {
  return (
    <section className="border border-zinc-950 mt-6" data-testid="oidc-section">
      <div className="border-b border-zinc-950 bg-zinc-950 text-white px-4 py-2 font-mono text-[11px] tracking-[0.2em] uppercase flex items-center justify-between">
        <span><Key size={12} className="inline mr-2" /> enterprise.sso (OIDC)</span>
        <span className="text-[10px]">{oidc?.configured ? "CONFIGURED" : "NOT CONFIGURED"}</span>
      </div>
      <div className="p-6">
        {oidc?.configured
          ? <ConfiguredView oidc={oidc} onRemove={onRemove} />
          : <OidcForm form={form} onChange={onFormChange} onSubmit={onSave} />}
      </div>
    </section>
  );
}
